import api from './api.ts';

export interface TopicTemplate {
  id: string;
  title: string;
  duration: number;
  type: string;
  category?: string;
  usageCount: number;
  createdAt: string;
}

export interface CreateTopicTemplateData {
  title: string;
  duration?: number;
  type?: string;
  category?: string;
}

export const topicTemplateService = {
  async getTemplates(category?: string): Promise<TopicTemplate[]> {
    const url = category ? `/api/topic-templates?category=${category}` : '/api/topic-templates';
    const response = await api.get(url);
    return response.data.data;
  },

  async getCategories(): Promise<string[]> {
    const response = await api.get('/api/topic-templates/categories');
    return response.data.data;
  },

  async createTemplate(data: CreateTopicTemplateData): Promise<TopicTemplate> {
    const response = await api.post('/api/topic-templates', data);
    return response.data.data;
  },

  async createTemplates(templates: CreateTopicTemplateData[]): Promise<{ count: number }> {
    const response = await api.post('/api/topic-templates/bulk', { templates });
    return response.data.data;
  },

  async updateTemplate(id: string, data: Partial<CreateTopicTemplateData>): Promise<TopicTemplate> {
    const response = await api.put(`/api/topic-templates/${id}`, data);
    return response.data.data;
  },

  async deleteTemplate(id: string): Promise<void> {
    await api.delete(`/api/topic-templates/${id}`);
  }
};